import { projectId, publicAnonKey } from './supabase/info';
import { logger } from './logger';

const BASE_URL = `https://${projectId}.supabase.co/functions/v1/make-server-3d4e1879`;

const cache = new Map<string, any>();

export async function apiRequest(
  endpoint: string,
  options: RequestInit = {},
  accessToken?: string,
  forceRefresh: boolean = false
) {
  const cacheKey = `${endpoint}:${JSON.stringify(options.body || {})}:${accessToken || 'anon'}`;
  
  if (!forceRefresh && options.method === 'GET' && cache.has(cacheKey)) {
    return cache.get(cacheKey);
  }

  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${accessToken || publicAnonKey}`,
    ...options.headers,
  };

  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      ...options,
      headers,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      logger.error(`API Error (${endpoint}):`, errorData);
      throw new Error(errorData.error || `Request failed with status ${response.status}`);
    }

    const data = await response.json();
    if (options.method === 'GET' || !options.method) {
      cache.set(cacheKey, data);
    } else if (options.method !== 'GET') {
      // Clear cache on mutations to ensure fresh data
      cache.clear();
    }
    
    return data;
  } catch (error) {
    logger.error(`API Request Error (${endpoint}):`, error);
    throw error;
  }
}